/**
 * Labels das fases do negócio (código -> texto exibido).
 * Alinhado com as opções usadas no form-generico (DefinicoesFormulario.FASE_NEGOCIO).
 */
export const FASE_NEGOCIO_LABELS: { [codigo: number]: string } = {
  1: '5% Lead de entrada',
  2: '20% Inventário ou familiares localizados',
  3: '30% Em contato - sem interesse',
  4: '50% Em contato - com interesse',
  5: '75% Negociação discutindo clausulas/percentual',
  6: '90% Contrato subiu pra assinatura',
  7: '100% Negócio fechado'
};

export function getFaseNegocioLabel(codigo: number | null | undefined): string {
  if (codigo == null) return '-';
  return FASE_NEGOCIO_LABELS[codigo] ?? '-';
}
